// Add error
export const addError = (message = 'error', type = 'sitewide', timeout = 1000) => {
	return {
		type: 'ADD_ERROR',
		options: {
			message,
			type,
			timeout,
		}
	}
}

// Remove error
export const removeError = (message = 'error', type = 'sitewide') => {
	return {
		type: 'REMOVE_ERROR',
		options: {
			message,
			type,
		}
	}
}



// WEBPACK FOOTER //
// ./src/actions/errors.js